import { render, staticRenderFns } from "./QApplicationsAuditTable.vue?vue&type=template&id=68a5f0b0&"
import script from "./QApplicationsAuditTable.vue?vue&type=script&lang=js&"
export * from "./QApplicationsAuditTable.vue?vue&type=script&lang=js&"
import style0 from "./QApplicationsAuditTable.vue?vue&type=style&index=0&id=68a5f0b0&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports